import { Link } from "react-router-dom";
import { LEGAL_LINKS } from "@jkast90/kast-common/legal";
import { THEME_MODES, type ThemeMode } from "@jkast90/kast-common/theme";
import type { Session } from "../hooks/useSession";
import type { Theme } from "../hooks/useTheme";

const THEME_LABELS: Record<ThemeMode, string> = { system: "System", light: "Light", dark: "Dark" };

/** The quiet end of the page: the small print, the theme and, out of the way, sign-in. */
export default function Footer({ session, theme }: { session: Session; theme: Theme }) {
  const { user, signIn, signOut } = session;
  return (
    <footer className="footer">
      <span className="muted small">Salvagers is a board game by Jake. Art is human-drawn.</span>
      <span className="muted small footer-legal">
        {LEGAL_LINKS.map((link, i) => (
          <span key={link.url}>
            {i > 0 && " · "}
            <a href={link.url}>{link.label}</a>
          </span>
        ))}
        {" · "}
        <Link to="/bug-report">Report a bug</Link>
      </span>
      <label className="muted small check">
        Theme
        <select
          className="small"
          value={theme.mode}
          onChange={(event) => theme.setMode(event.target.value as ThemeMode)}
        >
          {THEME_MODES.map((mode) => (
            <option key={mode} value={mode}>
              {THEME_LABELS[mode]}
            </option>
          ))}
        </select>
      </label>
      <span className="muted small footer-session">
        {user ? (
          <>
            <Link to="/account">{user.email}</Link>
            {" · "}
            <button className="link" onClick={signOut}>
              Sign out
            </button>
          </>
        ) : (
          <button className="link" onClick={signIn}>
            Sign in
          </button>
        )}
      </span>
    </footer>
  );
}
